import React from 'react';
import {FormattedMessage} from "react-intl";

export default {
    busy: <FormattedMessage id="prerecorded_messages.types.busy" defaultMessage="Busy"/>,
    unreachable: <FormattedMessage id="prerecorded_messages.types.unreachable" defaultMessage="Unreachable"/>
}


// WEBPACK FOOTER //
// ./src/constants/prerecordedMessageType.jsx